export const init = 0;
export const ready = 1;
export const sending = 2;
export const error = 3;